import script from "./SupervisorMobileTopNav.vue?vue&type=script&setup=true&lang=js"
export * from "./SupervisorMobileTopNav.vue?vue&type=script&setup=true&lang=js"

import "./SupervisorMobileTopNav.vue?vue&type=style&index=0&id=5382cfe5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5382cfe5"]])

export default __exports__